<mat-toolbar color="primary" class="app-toolbar">
  <span class="brand">OptixWay</span>
  <span class="spacer"></span>
  <button mat-icon-button [brMenuTriggerFor]="userMenu" aria-label="User menu" matTooltip="Account">
    <br-icon>account_circle</br-icon>
  </button>
  <ng-template #userMenu>
    <br-menu aria-label="User actions">
      <button brMenuItem (triggered)="logout()" label="Sign out" icon="logout"></button>
    </br-menu>
  </ng-template>
</mat-toolbar>
